import http from "../../shared/transactionApi"

const subscription = {
    state: {
        subscriptions: null, 
        paymentInfo: null,
        trials: null,
        pendingInvoices: null
    },
    actions: {
        fetchSubscriptions({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (!force) {
                    if (state.subscriptions) {
                        resolve(state.subscriptions)
                        return
                    }
                }

                http.get("/billing/subscription")
                .then((resp) => {
                    commit('SET_SUBSCRIPTIONS', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchTrials({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (!force) {
                    if (state.trials) {
                        resolve(state.trials)
                        return
                    }
                }

                http.get("/trial")
                .then((resp) => {
                    commit('SET_TRIALS', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchSubscriptionPaymentInfo({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/billing/subscription/payment_info")
                .then((resp) => {
                    commit('SET_PAYMENT_INFO', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchPendingInvoices({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (!force) {
                    if (state.pendingInvoices) {
                        resolve(state.pendingInvoices)
                        return
                    }
                }

                http.get("/billing/invoices/pending")
                .then((resp) => {
                    commit('SET_PENDING_INVOICES', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    commit('SET_PENDING_INVOICES', [])
                    reject(err)
                })
            })
        },
        
        
    },
    mutations: {
        SET_SUBSCRIPTIONS (state, sub) {   
            state.subscriptions = sub
        },

        SET_PAYMENT_INFO (state, info) {   
            state.paymentInfo = info
        },

        SET_TRIALS (state, trials) {
            state.trials = trials
        },

        SET_PENDING_INVOICES (state, invoices) {
            state.pendingInvoices = invoices
        },

        ADD_TRIAL (state, trial) {
            state.trials.push(trial)
        }
    },
    getters: {
        getSubscriptions(state) {
            if (!state.subscriptions) return []
            return state.subscriptions.filter(s => {
                // Include active subscriptions, trials, and expired subscriptions
                return (s.payment_status == "completed" && s.is_active) || 
                       (s.is_trial && s.is_active) || 
                       s.is_expired
            })
        },

        getSubscriptionPaymentInfo(state) {
            return state.subscription
        },

        getTrials(state) {
            if (!state.subscriptions) return []
            return state.subscriptions.filter(s => {
                return s.is_trial
            })
        },

        isTrialUsed(state) {
            return (productid) => {
                let trials = state.trials || []

                return trials.find(t => {
                    return t.product_id == productid
                })
            }
        },

        getPendingInvoices(state) {
            return state.pendingInvoices || []
        }
    }
  }

export default subscription